'use client'

import { useEffect } from 'react'
import Link from 'next/link'

function send(event: 'partner_landing_viewed' | 'partner_cta_clicked') {
  void fetch('/api/contractor-onboarding-events', {
    method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ event }), keepalive: true,
  })
}

export function PartnerLandingViewed() {
  useEffect(() => { send('partner_landing_viewed') }, [])
  return null
}

export function PartnerCTAEvent() {
  return <span onClick={() => send('partner_cta_clicked')} className="contents" />
}

export function PartnerSignupLink({ href, className, children }: { href: string; className: string; children: React.ReactNode }) {
  return <Link href={href} onClick={() => send('partner_cta_clicked')} className={className}>{children}</Link>
}
